module.exports = __webpack_public_path__ + "img/2.1b0ef445.jpg";